export default __webpack_public_path__ + "static/media/12.6050c3d8.jpg";